module.exports = __webpack_public_path__ + "static/img/banner1.c5eddf99.png";